import React from "react";

const Firebug = () => {
  return (
    <div className="wholeDiv">
      <div className="titleText">
        <b>Firebug</b>
      </div>
      <div className="helpDescription">
        <b>Information about the Firebug perk</b>
      </div>
      <div className="textBox">
        <div className="perkDescr">
          The <b>Firebug</b> specializes in setting enemies alight, using
          flame-based weapons to deal high area-of-effect damage. The Firebug
          perk emphasizes using incendiary weapons to burn down waves of enemies
          and clear areas of tough Zeds.
        </div>
        <div className="perkInfo">
          <b>Weapons</b>: The Firebug has access to flame-based weaponry. These
          weapons are perfect for dealing damage over time and creating barriers
          of fire to prevent enemies from advancing.
        </div>
        <div className="listText">
          <b>Benefits</b> acquired by leveling this perk:
          <div className="bonusList">
            <ul>
              <li>Bonuses for Firebug weapons:</li>
              <ul>
                <li>Increase in fire damage;</li>
                <li>Increase in fire speed;</li>
                <li>Increase in reload speed;</li>
                <li>Increase in amount ammunition magazines;</li>
                <li>Increase in pickup amount of ammunition;</li>
                <li>Discount on ammunition;</li>
                <li>Reduced weapon price;</li>
              </ul>
              <li>General bonuses:</li>
              <ul>
                <li>Increase in flamethrower range;</li>
                <li>Increase in fire damage reduction;</li>
                <li>Increase in carry weight;</li>
                <li>Increase in recoil control;</li>
              </ul>
            </ul>
          </div>
          <b>Team Role</b>: Firebugs excel in crowd control and can clear entire
          rooms or choke points with their flames. Their ability to cause
          consistent fire damage over time makes them especially effective
          against large groups or tougher Zeds.
        </div>
      </div>
    </div>
  );
};

export default Firebug;
